<template>
	<div class="post-smtp-settings-menu-wrapper">
		<div class="post-smtp-dropdown-menu" v-for="menu in menus">
			<a :href="menu.url" class="post-smtp-button">
				<post-smtp-img :fallback="'menu-fallback' === menu.icon" style="margin-bottom: -4px;margin-right: 8px;" :src="plugin_dir_url + 'assets/images/' + menu.icon + '.svg' " ></post-smtp-img>
				{{ menu.title }}
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PostSmtpSettingsMenu',

	inject: [ 'i18n' ],

	props: {
		menus: {
			type: Array,
			default: () => [],
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),
}
</script>

<style scoped>
.post-smtp-settings-menu-wrapper {
	width: 190px;
	height: 312px;


	border-radius: 4px;
	background: #FFF;
	box-shadow: 0px 0px 20px 0px rgba(35, 31, 32, 0.10);

	position: absolute;
	top: 60px;
	right: 41px;
}

.post-smtp-dropdown-menu {
	width: 100%;
	height: 52px;
}

.post-smtp-button:hover {
	background: #375CAF;
	color: #fff;
}

.post-smtp-button:hover img {
	filter: invert(100%);
}

.post-smtp-button img[fallback="true"] {
	filter: invert(100%);
}

.post-smtp-button:hover img[fallback="true"] {
	filter: invert(0);
}

.post-smtp-button {
	display: block;
	padding: 0 20px;
	line-height: 52px;

	color: #231F20;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	text-decoration: none;
}
</style>